import { FilterOperator } from 'generated/graphql';
import { Datagrid, DateField, List, SelectField, SelectInput, TextField } from 'react-admin';

import { ClientInput } from '../inputs/ClientInput';
import { CLIENT_STATUSES } from './clientUtils';

export const ClientList: React.FC = () => {
  const filters = [
    <ClientInput label="E-mail" source="id" sx={{ width: '40em' }} />,
    <SelectInput choices={CLIENT_STATUSES} label="Stav" source="status" />,
  ];

  return (
    <List
      exporter={false}
      // show only registered clients here = with user.subject
      filter={{
        filterCondition: {
          fieldPath: 'user.subject',
          operator: FilterOperator.IsNotNull,
          values: [],
        },
      }}
      filters={filters}
      sort={{ field: 'user.updateTimestamp', order: 'DESC' }}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField label="ID" source="id" />
        <TextField label="Meno" source="user.name" />
        <TextField label="Priezvisko" source="user.surname" />
        <TextField label="E-mail" source="user.email" />
        <TextField label="Tel." source="user.phoneNumber" />
        <SelectField choices={CLIENT_STATUSES} label="Stav" source="status" />
        <DateField label="Dátum vytvorenia" locales="sk" source="user.creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" source="user.updateTimestamp" />
      </Datagrid>
    </List>
  );
};
